export default __webpack_public_path__ + "static/media/unsere_haeuser_web-lg@1x.a9757d19.jpg";